var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Popup',{attrs:{"active":!!_vm.el,"target":_vm.el},on:{"onClose":_vm.closePopup}},[_c('NotesCompact')],1)}
var staticRenderFns = []

export { render, staticRenderFns }